import { render, staticRenderFns } from "./DiaoChaWenJuanJiaoNangZhuZhuangTu.vue?vue&type=template&id=24f0c75a&scoped=true&"
import script from "./DiaoChaWenJuanJiaoNangZhuZhuangTu.vue?vue&type=script&lang=js&"
export * from "./DiaoChaWenJuanJiaoNangZhuZhuangTu.vue?vue&type=script&lang=js&"
import style0 from "./DiaoChaWenJuanJiaoNangZhuZhuangTu.vue?vue&type=style&index=0&id=24f0c75a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f0c75a",
  null
  
)

export default component.exports